import { sendEvent } from 'lib/api/queries/personalization';
import { getDefaultDataWithEventType } from '../utils';
import { TRACKING_EVENT_PERSONALIZATION } from '../constants';

export const sendInitialSearchEvent = (data, query, config) => {
  const dataToSend = getDefaultDataWithEventType(
    {
      ...data,
    },
    query,
    TRACKING_EVENT_PERSONALIZATION.INITIAL_SEARCH_RESULTS,
  );

  sendEvent(dataToSend, config);
};
